/*
	Keep the optional-field validation workaround out of the vendor file and
	avoid assuming the global "$" alias is the active jQuery instance.
*/
(function () {

	const $ = window.jQuery || window.$;

	if (
		!$
		|| !$.validator
		|| !$.validator.prototype
		|| !$.validator.methods
		|| !$.validator.methods.required
	) {

		return;

	}

	$.extend($.validator.prototype, {
		optional: function (element) {

			// removed "dependency-mismatch" because !false && "dependency-mismatch"
			// evaluates to "dependency-mismatch" instead of true
			return !$.validator.methods.required.call(this, $.trim(element.value), element);

		}
	});

}());
